<template>
    <div class="training-lc-tiles">
        <training-learning-content-tile
            v-for="learningContent in learningContents"
            :key="learningContent.learningContent.id"
            :assignment="assignment"
            :course-progress="courseProgress"
            :learning-content="learningContent">
        </training-learning-content-tile>

        <training-certificate-tile
            v-if="assignment.is_certifiable"
            :assignment="assignment">
        </training-certificate-tile>
    </div>
</template>

<script>
export default {
    props: [
        'assignment',
        'courseProgress',
        'learningContents',
    ],
}
</script>
